<angular-editor [placeholder]="'Enter text here...'" [(ngModel)]="text" [config]="editorConfig" (ngModelChange)="textChanged($event)"></angular-editor>
